import { totalConversationsResolvedGauge } from 'ducks/reports/gauges'
import { HeadlineVisualization } from 'ducks/reports/visualizations'

const staticProps = {
  gauges: [totalConversationsResolvedGauge],
}
export default function TotalConveresationsResolvedHeadline(props) {
  return <HeadlineVisualization {...props} {...staticProps} />
}
